import axios from '@/api'
import {keycloak} from "../../api";

export default {
  namespaced : true,
  state : {
    currentUser : null,
    users : {
      users : [],
      pagination : {
        page: 1,
        limit: 10,
        total: 0,
        pages: 0,
        prev: null,
        next: null
      }
    },
    currentPage : 1,
    permissions : []
  },
  getters : {
    userCan : (state) => (permission) => {
      return true;
      return !!state.permissions.find(item => item.indexOf(permission) > -1)
    }
  },
  mutations : {
    SET_CURRENT_USER(state, payload){
      state.currentUser = payload;
    },
    SET_PERMISSIONS(state, payload){
      state.permissions = payload;
    },
    SET_CURRENT_PAGE(state, payload){
      state.currentPage = payload;
    }
  },
  actions: {
    getProfile({commit}){
      return new Promise((resolve, reject) => {
        axios.get(`/admin/users/me`)
          .then((response) => {
            commit('SET_CURRENT_USER',response.data);
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },
    getPermissions({commit}, payload){
      return new Promise((resolve, reject) => {
        axios.get(`/admin/users/permissions`)
          .then((response) => {
            let permissions = [];
            for(let key in response.data.permissions){
              for(let permission of response.data.permissions[key]){
                permissions.push(`${key}.${permission}`)
              }
            }
            commit('SET_PERMISSIONS',permissions);
            resolve(response.data)
          })
          .catch((error) => { reject(error) })
      })
    },
    logout({commit}){
      Keycloak.logout({redirectUri: window.location.origin});
    },
  }
}
